//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
import { sendCtmEvtLog } from '@/utils/log'
import MoreIcon from '@/components/views/_more_icon'
import ClientMark from '@/components/views/_client_mark'

import get_consultant_medal from '@/common/mixins/get_consultant_medal'
import ConsultantMedal from '@/components/business/consultant_medal'

const sendLog = (name) => {
    sendCtmEvtLog(`会话页面——点击${name}`)
}
export default {
    mixins: [
        get_consultant_medal
    ],
    components: {
        MoreIcon,
        ClientMark,
        ConsultantMedal,
    },
    props: {
        building: {
            type: Object
        },
        consultant: {
            type: Object
        },
        consultant_count: {
            type: Number
        },
        is_block: {
            type: Boolean
        },
        peer_nickname: {
            type: String
        },
        client_mark: {
            type: String
        }
    },
    computed: {
        show_switch () {
            return this.consultant_count > 1
        }
    },
    methods: {
        goConsultant () {
            wx.navigateTo({
                url: `/consultants/card/main?id=${this.consultant.id}`
            })
        },
        copyWx () {
            sendLog('复制微信')
            wx.copyByDomId('copy_wx', 'content')
        },
        callConsultant (e) {
            sendLog('电话咨询')
            this.$showCallModal(() => {
                this.$emit('getPhoneCall')
            }, '聊天页——置业顾问卡片电话拨打')
        },
        switchConsultant () {
            const { building_id } = this.consultant
            wx.navigateTo({
                url: `/consultants/filter/main?id=${building_id}`
            })
        },
        getMore() {
            const data = this.is_block ? ['取消屏蔽'] : ['屏蔽消息']
            wx.showActionSheet({
                itemList: data,
                success: (res) =>  {
                    this.$emit('changeBlock', data.join(''))
                }
            })
        }
    }
}
